<template>
  <div class="form-container step3">
    <div class="loader" v-if="isLoading"></div>
    <form id="topup-codes-step2" @submit.prevent="submit" novalidate>
      <div class="topup-error" v-if="topupError">
        <h3>Podczas przetwarzania doładowania wystapił błąd!</h3>
        <p>Spróbuj ponownie lub skonsultuj się z&nbsp;pomocą techniczną.</p>
      </div>
      <div class="form-row">
        <div class="summary">
          <div class="logo">
            <img :src="getOperatorLogoSrc(product)" :alt="product">
          </div>
          <div class="data">
            <div class="codes-wrapper">
              <p>
                <span>Kwota doładowania:</span>
                <span>{{ formData.amount | pln }} PLN</span>
              </p>
              <p>
                <span>Adres e-mail:</span>
                <span>{{ formData.notificationEmail }}</span>
              </p>
              <p>
                <span>Doładowanie:</span>
                <span>{{ productName }}</span>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div v-if="isProductActive(products.playstationPlus) || isProductActive(products.playstationStore)">
        <div class="form-row consents">
          <h3>Reklamacje i zwroty</h3>
        </div>
        <div class="form-row d-info">
          Zamówienie można anulować w ciągu 14 dni od daty dostarczenia kodu i uzyskać zwrot w wysokości ceny zakupu. W sprawach związanych z anulowaniem i z zwrotami prosimy kontaktować się z nami pod adresem email
          <a href="mailto:reklamacje_karty@autopay.pl">reklamacje_karty@autopay.pl</a>
        </div>
      </div>
      <div class="form-row form-buttons justify-content-between">
        <button type="button" class="btn btn-back" @click="goBack" :disabled="isLoading">Wstecz</button>
        <button type="submit" class="btn" :disabled="isLoading">Płacę</button>
      </div>
      <administrator-data-info />
    </form>
  </div>
</template>

<script>
import AdministratorDataInfo from '@/doladujtutaj/components/AdministratorDataInfo'
import OperatorMixin from '@/doladujtutaj/mixins/operator.mixin'
import ProductMixin from '@/doladujtutaj/mixins/product.mixin'
import { mapActions, mapMutations } from 'vuex'
import { TOPUP_RESPONSE_SUCCESS } from '@/common/const/topup.const'
import { ToolsClass } from '@/common/class/tools.class'

export default {
  name: 'TopupCodesStep3',
  components: { AdministratorDataInfo },
  mixins: [OperatorMixin, ProductMixin],
  data () {
    return {
      topupError: false
    }
  },
  methods: {
    ...mapMutations([
      'SET_VOUCHER_STAGE',
      'SET_VOUCHER_LOADING'
    ]),
    ...mapActions([
      'startVoucherPayment',
      'setVoucherStage2Data'
    ]),
    goBack () {
      this.SET_VOUCHER_STAGE(2)
    },
    scrollToLoader () {
      setTimeout(() => {
        ToolsClass.scrollToElement(document.querySelector('.loader'), -120, 'smooth')
      }, 100)
    },
    submit () {
      this.topupError = false
      this.SET_VOUCHER_LOADING(true)
      this.scrollToLoader()
      this.startVoucherPayment()
        .then(response => {
          if (response.body.status === TOPUP_RESPONSE_SUCCESS && response.body.paymentLink) {
            window.parent.location.href = response.body.paymentLink
            return
          }

          this.SET_VOUCHER_LOADING(false)
          this.topupError = true
        })
        .catch(() => {
          this.SET_VOUCHER_LOADING(false)
          this.topupError = true
        })
    }
  },
  updated () {
    ToolsClass.sendHeightToIframeParent()
  }
}
</script>
